import { FiInfo } from 'react-icons/fi';
import { Counter, LikeButton, RegVideo, Video } from "../../../../src/components/Complete";
import { Link } from 'gatsby';
import * as React from 'react';
export default {
  FiInfo,
  Counter,
  LikeButton,
  RegVideo,
  Video,
  Link,
  React
};